import { Link, useLocation } from 'react-router-dom';
import './styles/Menu.scss'
import { useEffect, useState } from 'react';
import { SECTION_TILES, useSections } from '../sections';
import SectionIcon from './SectionIcon';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
}

export default function Menu({ inner }: any) {
    const [mobile, setMobile] = useState(getWindowDimensions().width < 950);
    const [invisible, setInvisible] = useState(true);
    const { hasSection } = useSections();
    const location = useLocation();

    useEffect(() => {
        function handleResize() {
            setMobile(getWindowDimensions().width < 950);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const navSections = SECTION_TILES.filter(t => t.ready && t.section !== "Account" && hasSection(t.section));

    function isActive(route: string, exact = false) {
        return exact ? location.pathname === route : location.pathname.startsWith(route);
    }

    return (
        <div className={"menu " + (inner ? "inner " : "") + (mobile ? "mobile" : "")}>
            <Link to={inner ? "/kurz" : "/"} >
                <img className={"logo " + (mobile ? "mobile" : "")} src="/images/common/logo.png" alt="MyMed" width={508} height={101} />
            </Link>

            {mobile && <img onClick={() => setInvisible(!invisible)} className={"button " + (invisible ? "invisible" : "")} src="/images/components/button.png" alt="Menu" width={150} height={136} />}

            <div onClick={() => setInvisible(!invisible)} className={"links " + (mobile ? "mobile " : "") + (invisible ? "invisible" : "")}>
                {!inner ?
                    <>
                        <Link to="/kontakty" >Kontakty</Link>
                        <Link to="/blog" >Blog</Link>
                        <Link to={(localStorage.getItem("token") === null) ? "/prihlaseni" : "/kurz"}><p>Kurz</p></Link>
                    </>
                    :
                    <>
                        <Link className={"navItem" + (isActive("/kurz", true) ? " active" : "")} to="/kurz">
                            <span className="navIcon"><SectionIcon section="Dashboard" /></span>
                            <span>Domů</span>
                        </Link>

                        {navSections.map(t => (
                            <Link key={t.section} className={"navItem" + (isActive(t.route) ? " active" : "")} to={t.route}>
                                <span className="navIcon"><SectionIcon section={t.section} /></span>
                                <span>{t.title}</span>
                            </Link>
                        ))}

                        <Link className={"navItem account" + (isActive("/kurz/ucet") ? " active" : "")} to="/kurz/ucet">
                            <span className="navIcon"><SectionIcon section="Account" /></span>
                            <p>Účet</p>
                        </Link>
                    </>
                }
            </div>
        </div>
    );
}
